import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import {
  AreaDataIn,
  Client,
  GuidDictionaryItem,
} from '../../../../../api/api-reference';

@Component({
  selector: 'app-area-setup',
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, AngularSvgIconModule],
  templateUrl: './area-setup.component.html',
  styleUrl: './area-setup.component.scss',
})
export class AreaSetupComponent implements OnInit {
  @Input() selectedArea: string | null = null;
  @Output() close = new EventEmitter<boolean>();
  data: AreaDataIn = new AreaDataIn();

  regions: GuidDictionaryItem[] = [];

  @ViewChild('crudform') crudform!: NgForm;
  constructor(
    private client: Client,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getArea();
    this.getRegions();
  }

  toggleModal(reaload?: boolean) {
    this.close.emit(reaload);
  }

  getArea() {
    if (this.selectedArea) {
      this.client.getArea(this.selectedArea).subscribe({
        next: (response) => {
          this.data.id = response.id;
          this.data.name = response.name ?? '';
          this.data.code = response.code ?? '';
          this.data.regionId = response.regionId ?? '';
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    }
  }

  onSubmit() {
    this.client.saveArea(this.data).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.toggleModal(true);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  getRegions() {
    this.client.getAllRegionsForOptions().subscribe({
      next: (response) => {
        this.regions = response ?? [];
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
